import { ForwardedRef, ReactNode } from 'react'

import classNames from 'classnames'

import styles from './ListFilterButtonWrapper.module.scss'

interface Props {
  children: ReactNode
  wrapperClassName?: string
  wrapperRef?: ForwardedRef<HTMLSpanElement>
}
function ListFilterButtonWrapper(props: Props) {
  const { children, wrapperClassName, wrapperRef } = props

  return (
    <span ref={wrapperRef} className={classNames(styles.btn_wrapper, wrapperClassName)}>
      {children}
    </span>
  )
}

export default ListFilterButtonWrapper
